exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n    display: grid;\n    padding: 0;\n}\n\n:host h2 ptooltip {\n    font-family: Roboto, Noto, sans-serif;\n    font-size: 14px;\n    font-weight: 400;\n}\n\n.mylabel {\n    margin: 2px;\n    display: inline-block !important;\n    cursor: pointer;\n    font-size: 14px !important;\n    white-space: inherit;\n}\n\n.card-content {\n    position: relative;\n}\n\n.tooltip-text {\n    display: inline-table;\n}\n\n.tooltip-text ::ng-deep ul {\n    padding-left: 15px;\n}\n\n.pheader h2 {\n    margin-top: 0;\n}\n\n.description {\n    grid-column: span 1;\n}\n\n.grid-content {\n    display: grid;\n    grid-template-columns: auto;\n    grid-column-gap: 10px;\n    grid-row-gap: 10px;\n    grid-auto-flow: row;\n}\n\n@media only screen and (min-width: 400px) {\n    .description {\n        grid-column: span 2;\n    }\n\n    .grid-content {\n        grid-template-columns: 1fr 1fr;\n    }\n}\n\n.tt-container {\n    display: grid;\n    grid-template-columns: auto 1fr;\n}\n\n.tt-label {\n    grid-column: 1;\n    margin: 1px 2px auto 2px;\n}\n\ntt-tooltip {\n    grid-column: 2;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/comparison/details/comparison.details.component.css
// module id = ./src/app/components/comparison/details/comparison.details.component.css
// module chunks = main